import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    findTypeItemsAction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/item/find-type-items`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    storeItemAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/item/store`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateItemAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/item/update/${payload.get("item_id")}`, payload)
          .then((res) => {
            resolve(res.data.item);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findItemsParamsAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/item/find-by-params`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deletePhotoItemAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/item/delete-photo`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    reportItemAction(Context, typeId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/item/report`, { type_id: typeId })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteItemAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/item/delete`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });

    }
  },
};

export default store;
